import React from 'react';
import SheildExpiredIcon from '../../library/icons/shield-expired-icon';

const MagicLinkExpiredComponent = () => {
    return (
        <div className="linkcontent">
            <div className="img">
                <SheildExpiredIcon />
            </div>
            <h2>This share link has expired</h2>
            <p>Please contact your account manager to arrange a new share link.</p>
        </div>
    );
};

export default MagicLinkExpiredComponent;
